// eslint-disable-next-line import/prefer-default-export
export const ActivityStatuses = {
  notStarted: 0,
  doing: 1,
  rejected: 2,
  done: 3,
};
